// JsFromRoutes CacheKey 3e3db99239309bb34401e3ef80afac49
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from 'utils/js_from_routes_client'

export default {
  index: /* #__PURE__ */ definePathHelper('get', '/members/reimbursements'),
  new: /* #__PURE__ */ definePathHelper('get', '/members/reimbursements/new'),
  show: /* #__PURE__ */ definePathHelper('get', '/members/reimbursements/:id'),
}
